import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { actions as ppcActions } from '../../reducers/ppc.reducer';
import Button from '../common/Button.react';
import Label from '../common/form/Label.react';
import Checkbox from '../common/form/Checkbox.react';
import Input from '../common/form/Input.react';
import AddImage from '../common/assets/add-image/AddImage.button';
import ReCrop from '../common/assets/add-image/ReCrop.button';
import SelectPpcProduct from '../common/form/select/SelectPpcProduct.react';
import SelectPpcProductCategory from '../common/form/select/SelectPpcProductCategory.react';
import SelectPpcService from '../common/form/select/SelectPpcService.react';
import SelectPpcServiceCategory from '../common/form/select/SelectPpcServiceCategory.react';
var SlideButton = function SlideButton(_ref) {
  var slideID = _ref._id,
    button = _ref.button,
    _onChange = _ref.onChange;
  var dispatch = useDispatch();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", {
    style: {
      marginTop: 20
    }
  }, "Button"), /*#__PURE__*/React.createElement("div", {
    className: "slide__text"
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: button === null || button === void 0 ? void 0 : button.isVisible,
    label: "Show Button",
    onChange: function onChange(val) {
      _onChange('isVisible', val);
    }
  }), /*#__PURE__*/React.createElement(Input, {
    placeholder: "Label",
    value: button === null || button === void 0 ? void 0 : button.label,
    onChange: function onChange(e) {
      _onChange('label', e.target.value);
    }
  }), /*#__PURE__*/React.createElement(Input, {
    placeholder: "URL",
    value: button === null || button === void 0 ? void 0 : button.internalUrl,
    onChange: function onChange(e) {
      _onChange('internalUrl', e.target.value);
    }
  })));
};
export default SlideButton;